import { useState, useEffect } from 'react';
import { debounce } from 'lodash';

/**
 * Checks wheter or not the page is in mobile viewport, adding a listener to the 'resize' event.
 * The hook is debounced to prevent a rapid fire of events when resizing in a desktop browser.
 * @param {number} breakpoint the breakpoint below which the page is considered mobile
 * @param {number} debounceRate the rate at which fire the debounced hook
 * @returns true if the page is on a mobile viewport
 */
const useWithMobileResizeListener = (breakpoint, debounceRate = 1000) => {
  const [isMobile, setMobile] = useState(false);
  useEffect(() => {
    setMobile(window.innerWidth < breakpoint);
  }, [breakpoint]);

  useEffect(() => {
    const listener = debounce(() => {
      setMobile(window.innerWidth < breakpoint);
    }, debounceRate);
    window.addEventListener('resize', listener);
    return () => {
      window.removeEventListener('resize', listener);
    };
  }, [breakpoint, debounceRate]);
  return isMobile;
};
export { useWithMobileResizeListener };
export default useWithMobileResizeListener;
